<svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 576 512"
    [class]="className"
>
    <path d="M96 360C96 355.6 99.58 352 104 352H184C188.4 352 192 355.6 192 360C192 364.4 188.4 368 184 368H104C99.58 368 96 364.4 96 360zM224 360C224 355.6 227.6 352 232 352H376C380.4 352 384 355.6 384 360C384 364.4 380.4 368 376 368H232C227.6 368 224 364.4 224 360zM0 96C0 60.65 28.65 32 64 32H512C547.3 32 576 60.65 576 96V416C576 451.3 547.3 480 512 480H64C28.65 480 0 451.3 0 416V96zM16 96V416C16 442.5 37.49 464 64 464H512C538.5 464 560 442.5 560 416V96C560 69.49 538.5 48 512 48H64C37.49 48 16 69.49 16 96z"/>
</svg>
